(() => {
  $(document).on('click', '.product-form__custom-and-buy', function(event) {
    event.preventDefault();
    const button = this;
    if (button.dataset.sgPending === 'true') return;
    const scope = button.closest('[data-section-type="product"]');
    const calculator = scope?.querySelector('sizing-calculator');
    const form = scope?.querySelector('form[data-product-form]');
    const nativeButton = form?.querySelector('.product-form__cart-submit');
    const error = scope?.querySelector('[data-sg-cut-error]');
    const showError = (reason = 'cart-request', status) => {
      if (error) { error.hidden = false; error.dataset.sgFailure = reason; }
      console.warn('Status Grass basket request failed', {stage: reason, status: status ?? null});
    };
    const setStatus = key => {
      const label = button.querySelector('[data-sg-cut-status]');
      const live = scope?.querySelector('[data-sg-cut-live]');
      const text = key ? label?.dataset[key] || '' : '';
      if (label && text) label.textContent = text;
      if (live) live.textContent = text;
    };
    if (!calculator || !form || !nativeButton || nativeButton.disabled || !calculator.validateSelection()) { showError('selection-not-ready'); return; }
    const widthInput = calculator.querySelector('.width-input');
    const lengthInput = calculator.querySelector('#length-input');
    const selectedWidth = widthInput?.value.trim() || '';
    const widthNumber = parseFloat(selectedWidth.replace(',', '.'));
    const lengthNumber = parseFloat((lengthInput?.value || '').replace(',', '.'));
    const rate = parseFloat(calculator.getAttribute('data-per-meter'));
    const areaNumber = widthNumber * lengthNumber;
    const price = Number((areaNumber * rate).toFixed(2));
    let productData, selectedVariant, productVariants;
    const normalize = value => String(value || '').trim().toLowerCase().replace(/\s/g, '');
    const scripts = [
      document.getElementById('ProductJson-' + scope.dataset.sectionId),
      scope.closest('.shopify-section')?.querySelector('script[id^="ProductJson-"]'),
      scope.querySelector('script[data-variant-json]')
    ].filter(Boolean);
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent || 'null');
        const variants = Array.isArray(data) ? data : data?.variants;
        if (!Array.isArray(variants)) continue;
        const match = variants.find(variant => variant.id && normalize(variant.option1 || variant.options?.[0] || variant.title) === normalize(selectedWidth));
        if (match) { selectedVariant = match; productData = data; productVariants = variants; break; }
      } catch {}
    }
    const productId = productData?.id || form.querySelector('[name="product-id"]')?.value || scope.querySelector('[name="product-id"]')?.value;
    const variantId = selectedVariant?.id;
    if (selectedVariant?.available === false) { showError('selection-unavailable'); return; }
    const missing = [];
    if (!Number.isFinite(widthNumber) || widthNumber <= 0) missing.push('width');
    if (!Number.isFinite(lengthNumber) || lengthNumber <= 0) missing.push('length');
    if (!productId) missing.push('product');
    if (!variantId) missing.push('variant');
    if (!Number.isFinite(price) || price <= 0) missing.push('price');
    if (missing.length) {
      if (error) error.dataset.sgMissing = missing.join(', ');
      console.warn('Status Grass missing selection fields', missing);
      showError('selection-data');
      return;
    }
    const width = widthNumber + ' m', length = lengthNumber + ' m', area = areaNumber.toFixed(2) + ' m²';
    for (const [name, value] of Object.entries({Width: width, Length: length, 'Total area': area})) {
      let input = form.querySelector('[name="properties[' + name + ']"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + name + ']'; form.append(input); }
      input.value = value;
    }
    if (error) error.hidden = true;
    const inputs = [...calculator.querySelectorAll('input, select')];
    const disabled = inputs.map(input => input.disabled);
    let stage = 'pricing', cleanupTimer, handoffTimer;
    button.dataset.sgPending = 'true';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    setStatus('creating');
    inputs.forEach(input => { input.disabled = true; });
    const finish = (failed, reason = stage, status) => {
      clearTimeout(cleanupTimer);
      clearTimeout(handoffTimer);
      document.removeEventListener('cart:updated', onCart);
      document.removeEventListener('cart:error', onError);
      inputs.forEach((input, i) => { input.disabled = disabled[i]; });
      delete button.dataset.sgPending;
      delete form.dataset.sgCutSubmitting;
      button.removeAttribute('aria-busy');
      button.classList.remove('loading');
      setStatus();
      calculator.computeAndRender();
      if (failed) showError(reason, status);
    };
    const onCart = event => {
      if (stage === 'cart' && event.detail?.cart?.items?.some(item => String(item.variant_id || item.id) === form.dataset.sgCutVariantId)) finish(false);
    };
    const onError = () => { if (stage === 'cart') finish(true); };
    document.addEventListener('cart:updated', onCart);
    document.addEventListener('cart:error', onError);
    const submitCut = (variant, delay = 0) => {
      const id = String(variant);
      try {
        localStorage.setItem('new_variant_id', id);
        form.dataset.sgCutVariantId = id;
        const submit = () => {
          try {
            stage = 'cart';
            setStatus('adding');
            localStorage.setItem('new_variant_id', id);
            form.querySelectorAll('.product-form__variants, [name="id"]').forEach(input => input.remove());
            for (const [name, value] of Object.entries({Width: width, Length: length, 'Total area': area})) {
              const input = form.querySelector('[name="properties[' + name + ']"]');
              if (input) input.value = value;
            }
            cleanupTimer = setTimeout(() => finish(true), 45000);
            form.dataset.sgCutSubmitting = 'true';
            nativeButton.click();
          } catch { finish(true, 'cart-handoff'); }
        };
        if (delay) handoffTimer = setTimeout(submit, delay);
        else submit();
      } catch { finish(true, 'cart-storage'); }
    };
    try {
      delete form.dataset.sgCutVariantId;
      localStorage.removeItem('new_variant_id');
      const cutTitle = normalize(widthNumber + 'mx' + lengthNumber + 'm=' + areaNumber.toFixed(2) + 'm²');
      const existingCut = productVariants?.find(variant =>
        /^\d+$/.test(String(variant.id || '')) &&
        variant.available === true &&
        normalize(variant.option1 || variant.options?.[0] || variant.title) === cutTitle &&
        Number(variant.price) === Math.round(price * 100)
      );
      if (existingCut) { submitCut(existingCut.id); return; }
      $.ajax({
        type: 'POST',
        url: 'https://mektra.appsdroplogicx.uk/price_increase',
        data: {product_id: productId, variant_id: variantId, price, properties: {Width: width.replace(/\s/g, ''), Length: length.replace(/\s/g, ''), 'Total area': area.replace(/\s/g, '')}},
        dataType: 'json',
        timeout: 20000,
        success: data => {
          if (!data?.status || !/^\d+$/.test(String(data.variant_id || ''))) { finish(true, 'pricing-response'); return; }
          submitCut(data.variant_id);
        },
        error: xhr => finish(true, 'pricing-transport', xhr?.status)
      });
    } catch { finish(true); }
  });
  document.addEventListener('submit', event => {
    if (window.StatusCutService?.enabled) return;
    const form = event.target;
    if (!form.matches('form[data-product-form]') || !form.querySelector('[name="properties[Total area]"]')) return;
    const scope = form.closest('[data-section-type="product"]');
    if (!scope?.querySelector('sizing-calculator')) return;
    try {
      if (!form.dataset.sgCutVariantId || form.dataset.sgCutSubmitting !== 'true') throw new Error('Size not prepared');
      localStorage.setItem('new_variant_id', form.dataset.sgCutVariantId);
      delete form.dataset.sgCutSubmitting;
    } catch {
      event.preventDefault();
      event.stopImmediatePropagation();
      const error = scope.querySelector('[data-sg-cut-error]');
      if (error) error.hidden = false;
    }
  }, true);
})();
function updateURLParameter(key, value) {
  const url = new URL(window.location);
  url.searchParams.set(key, value);
  window.history.pushState({}, '', url);
}
